import { Flex, PageContainer, RetryAlert } from '@/components';

export function PageError({
  title,
  content,
  action,
  actionText = undefined
}) {
  return (
    <PageContainer title={title}>
      <Flex align="center" className="h-full pb-20">
        <RetryAlert noIcon actionText={actionText} content={content} action={action} />
      </Flex>
    </PageContainer>
  );
}

export default PageError;
